export default __webpack_public_path__ + "static/media/Strugani 26.b62b8be0.jpg";